/**
 * SignInPage - Professional login for MediaLabs
 */
import { SignIn } from '@clerk/clerk-react';
import { Wand2 } from 'lucide-react';

const SignInPage = () => {
  return (
    <div className="auth-page" data-testid="sign-in-page">
      <div className="auth-bg-grid" />
      <div className="auth-bg-glow auth-bg-glow-1" />
      <div className="auth-bg-glow auth-bg-glow-2" />

      <div className="auth-container">
        <div className="auth-header">
          <div className="auth-logo" data-testid="auth-logo">
            <div className="auth-logo-mark">
              <Wand2 size={22} />
            </div>
            <span className="auth-logo-text">MediaLabs</span>
          </div>
          <h1 className="auth-title">Bienvenido de vuelta</h1>
          <p className="auth-subtitle">
            Inicia sesión en tu estudio creativo
          </p>
        </div>
        
        <div className="auth-form-container">
          <SignIn 
            routing="path" 
            path="/sign-in"
            signUpUrl="/sign-up"
            fallbackRedirectUrl="/studio"
            appearance={{
              layout: {
                socialButtonsPlacement: 'top',
                socialButtonsVariant: 'blockButton',
                showOptionalFields: false,
                logoPlacement: 'none',
              },
              elements: {
                rootBox: 'auth-clerk-root',
                card: 'auth-clerk-card',
                header: 'auth-clerk-header-hidden',
                headerTitle: 'auth-clerk-header-hidden',
                headerSubtitle: 'auth-clerk-header-hidden',
                socialButtonsBlockButton: 'auth-clerk-social-btn',
                formButtonPrimary: 'auth-clerk-primary-btn',
                formFieldInput: 'auth-clerk-input',
                formFieldLabel: 'auth-clerk-label',
                footerActionLink: 'auth-clerk-link',
                footerAction: 'auth-clerk-footer',
                dividerLine: 'auth-clerk-divider-line',
                dividerText: 'auth-clerk-divider-text',
                identityPreview: 'auth-clerk-identity',
                formFieldAction: 'auth-clerk-field-action',
                alert: 'auth-clerk-alert',
                alertText: 'auth-clerk-alert-text',
                otpCodeFieldInput: 'auth-clerk-otp',
              },
              variables: {
                colorPrimary: '#6366f1',
                colorBackground: 'transparent',
                colorText: '#f1f5f9',
                colorTextSecondary: '#94a3b8',
                colorInputBackground: 'rgba(15, 23, 42, 0.6)',
                colorInputText: '#f1f5f9',
                colorDanger: '#f43f5e',
                borderRadius: '10px',
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
                fontSize: '0.9rem',
              }
            }}
          />
        </div>

        <p className="auth-footer-note">
          Estudio de generación de media con IA
        </p>
      </div>
    </div>
  );
};

export default SignInPage;
